import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { TreePersonCard } from '@/components/person/TreePersonCard';
import { useHybridPedigreeStore } from '@/hooks/useStores';

interface ParentsGenerationProps {
  onTreeViewClick?: (familyMemberId: string) => void;
  onProfileClick?: (familyMemberId: string) => void;
  onAddClick?: (familyMemberId: string, option: 'child' | 'spouse' | 'parent' | 'pet') => void;
  canAddByMemberId?: Record<string, boolean>;
}

const ParentsGeneration: React.FC<ParentsGenerationProps> = observer(
  ({ onTreeViewClick, onProfileClick, onAddClick, canAddByMemberId = {} }) => {
    const { t } = useTranslation('pedigree');
    const hybridPedigreeStore = useHybridPedigreeStore();
    const { leftParentFamilyMemberId, rightParentFamilyMemberId } = hybridPedigreeStore.parentsGen;

    return (
      <div className="generation generation-parents">
        <span className="generation-label" aria-hidden>
          {t('generations.parents')}
        </span>
        <div className="partnership">
          {leftParentFamilyMemberId && (
            <TreePersonCard
              familyMemberId={leftParentFamilyMemberId}
              generation={-1}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[leftParentFamilyMemberId] ?? false}
              isTreeAnchor={false}
            />
          )}
          {rightParentFamilyMemberId && (
            <TreePersonCard
              familyMemberId={rightParentFamilyMemberId}
              generation={-1}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[rightParentFamilyMemberId] ?? false}
              isTreeAnchor={false}
            />
          )}
        </div>
      </div>
    );
  }
);

export default ParentsGeneration;
